import transitionEndEvent from '../events/transition'
import Flickity from 'flickity'

export default (function() {

  let resizeHandlers = [];

  function init() {

    if (resizeHandlers.length) {
      resizeHandlers.forEach(() => {
        window.removeEventListener('optimizedResize', resizeHandler)
      })
      resizeHandlers = []
    }

    const carousels = Array.from(document.querySelectorAll('.casestudy-carousel'))
    if (carousels.length > 0) {
      carousels.forEach(function(carouselElement) {
        var flkty = new Flickity(carouselElement, {
          // options
          cellAlign: 'left',
          contain: true,
          cellSelector: '.casestudy-carousel__slide',
          pageDots: false,
          wrapAround: true,
          imagesLoaded: true,
          percentPosition: false,
          prevNextButtons: true,
          autoPlay: 4000,
          pauseAutoPlayOnHover: false
        });
        flkty.pausePlayer();

        let resizeHandler = () => {
          flkty.resize()
        }

        let leftArrow = carouselElement.querySelector('.slideshow-navigation--prev')
        let rightArrow = carouselElement.querySelector('.slideshow-navigation--next')

        leftArrow.addEventListener('click', function(e) {
          e.preventDefault();
          flkty.pausePlayer();
          flkty.previous();
        })

        rightArrow.addEventListener('click', function(e) {
          e.preventDefault();
          flkty.pausePlayer();
          flkty.next();
        })

        window.addEventListener('optimizedResize', resizeHandler)
      })
    }
  }

  return {
    init,
  }

})();
